export const drillDownTabsSx = {
  px: 2,
  minHeight: 34,
  borderBottom: 1,
  borderColor: "divider",
  "& .MuiTabs-indicator": {
    height: 2,
  },
};

export const drillDownTabSx = {
  minHeight: 34,
  px: 1.25,
  py: 0.5,
  minWidth: 0,
  textTransform: "none",
  fontSize: 12,
  fontWeight: 500,
  alignItems: "flex-start",
};
